import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import moment from "moment";
import Heading from "../../AdminPanel/Component/UI/Heading";
import AssessmentCard from "./Component/AssessmentCodeCard";

class OverviewNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crrTeamId: "",
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    const temp2 = {
      keyWord: "",
      pageNo: 1,
      size: 100000,
    };
    this.props.dispatch(
      assessmentActions.getCompletedTeamList(temp2, "report")
    );
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  handleViewAllCodes = (item) => {
    if (this.props.navigate) {
      this.props.navigate("/assessment/assessmentcode-list", { state: { cardData: item } });
    }
    else if (this.props.history) {
      this.props.history.push("/assessment/assessmentcode-list");
    }
    else {
      window.location.href = "/assessment/assessmentcode-list";
    }
  };

  render() {
    const { crrTeamId } = this.state;
    const { assessment } = this.props;
    const { userAssessmentUserProfileData } = assessment;

    const getPeriod = () => {
      const hour = moment().hour();
      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod(),
    };

    let { loading } = assessment;

    const cardList = [
      {
        id: 1,
        title: "TalentPlusStrengths 28",
        description:
          "To understand all themes and identify your strengths, take the assessment TalentPlusStrengths 28.",
        count: 256,
        imageUrl: "/img/Home/assessment_survey.webp",
      },
      {
        id: 2,
        title: "Top 5 Teen TalentPlusStrengths",
        description:
          "To understand all themes and identify your strengths, take the assessment TalentPlusStrengths 28.",
        count: 256,
        imageUrl: "/img/Home/assessment_survey.webp",
      },
      {
        id: 3,
        title: "Top 5 TalentPlusStrengths",
        description:
          "To understand all themes and identify your strengths, take the assessment TalentPlusStrengths 28.",
        count: 256,
        imageUrl: "/img/Home/assessment_survey.webp",
      },
    ];

    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="flex items-center justify-center max-w-3xl mx-auto py-4">
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 rounded-xl bg-indigo-600 text-white font-semibold flex items-center justify-center shadow-md shadow-indigo-200">1</div>
              <span className="mt-2 text-base font-semibold text-indigo-600">Assesbaseent code</span>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4 self-center mb-6" />
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-400 font-semibold flex items-center justify-center">2</div>
              <span className="mt-2 text-base font-medium text-gray-500">Upload Users</span>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4 self-center mb-6" />
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-400 font-semibold flex items-center justify-center">3</div>
              <span className="mt-2 text-base font-medium text-gray-500">Create Team</span>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4 self-center mb-6" />
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-400 font-semibold flex items-center justify-center">4</div>
              <span className="mt-2 text-base font-medium text-gray-500">Results</span>
            </div>
          </div>

          <div className="border-b border-gray-300" />

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <Heading className="text-2xl font-medium" title="Assessment Code" />
              <p className="mt-1 text-sm text-gray-600">Manage and monitor AI-driven competency surveys across your organization.</p>
            </div>
            <button className="inline-flex items-center justify-center px-3 py-3 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white font-medium text-base transition-colors duration-200 shadow-sm hover:shadow-indigo-100">Get Assessment Code</button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-4">
            {cardList.map((item) => (
              <AssessmentCard
                key={item.id}
                title={item.title}
                description={item.description}
                count={item.count}
                imageUrl={item.imageUrl}
                onViewAll={() => this.handleViewAllCodes(item)}
              />
            ))}
          </div>

        </div>
      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment,
  };
}

export default connect(mapStateToProps)(OverviewNew);